import React from "react";
import * as R from "ramda";

import { DropdownAsync } from "ui-kit/Form/View";

import { components } from "react-select";

import Avatar from "Portal/NewPortal/Shared/Avatar";
import { EVENT_SWITCHER_DROPDOWN_ID } from "../HeaderBar/constants";

const Control = ({ children, ...props }) => {
  const name = R.pathOr("", ["selectProps", "value", 0, "name"], props);
  const id = R.pathOr("", ["selectProps", "value", 0, "id"], props);
  return (
    <components.Control {...props}>
      {id !== "all" && (
        <Avatar
          {...{
            id,
            name,
            square: true,
            longInitials: true
          }}
        />
      )}
      {children}
    </components.Control>
  );
};
const Option = props => {
  const name = R.pathOr("", ["data", "name"], props);
  const id = R.pathOr("", ["data", "id"], props);
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerProps
  } = props;
  return (
    <div
      {...innerProps}
      style={{
        ...getStyles("option", props),
        display: "flex",
        gap: "10px",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        paddingLeft: "8px"
      }}
      className={cx(
        {
          option: true,
          "option--is-disabled": isDisabled,
          "option--is-focused": isFocused,
          "option--is-selected": isSelected
        },
        className
      )}
    >
      {id === "all" && <div style={{ width: "23.99px" }}></div>}
      {id !== "all" && (
        <Avatar
          {...{
            id,
            name,
            square: true,
            longInitials: true
          }}
        />
      )}
      {children}
    </div>
  );
};

const EventSwitcher = ({
  portal = {},
  fieldId = EVENT_SWITCHER_DROPDOWN_ID
}) => {
  let { event = {} } = portal || {};
  let { name = "", id = {} } = event || {};

  if (R.isEmpty(event) && fieldId !== EVENT_SWITCHER_DROPDOWN_ID) {
    name = "All Events";
    id = "all";
    event = { name, id };
  }

  return (
    <DropdownAsync
      fieldId={fieldId}
      iniValue={
        R.isNil(event) || R.isEmpty(event)
          ? []
          : {
              value: id,
              label: name,
              ...event
            }
      }
      multipleSelect={false}
      loadOptionsOnFocus={true}
      components={{
        IndicatorSeparator: null,
        Control,
        Option
      }}
      isClearable={false}
      usePortalHeaderStyle
      menuPlacement={"auto"}
    />
  );
};

export default EventSwitcher;
